import _ from 'lodash'
import React, { useEffect } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import {
  UncontrolledTooltip,
  Button,
  Card,
  Col,
  Container,
  Modal,
  Row
} from 'reactstrap'

import CustomPagination from 'components/Pagination'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import PageTitle from 'components/Title/PageTitle'
import Moment from 'moment'
import SearchForm from 'components/SearchForm'
import DeleteConfirmationModal from 'components/Modal/deleteConfirmation'

import ProgrammeHOC from './actions'
import ProgrammeForm from './Form'

import Lang from 'Lang/General'

const Programme = props => {

  useEffect(() => {
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Fair' })
    props.onChangeProgrammeHOC('subscribedPackage', tmpIndex > -1)
    props.getAnchorLinks(props.data.selectCenterReducer.selectedCenter.center.site.id)
    props.getPages(props.data.selectCenterReducer.selectedCenter.center.site.id)
  }, [])

  useEffect(() => {
    props.getProgramme({
      filter: { "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id },
      page: 1,
      is_paginated: true,
    })
    props.onChangeProgrammeHOC('defaultQuery', {
      filter: { "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id },
      page: 1,
      is_paginated: true,
    })
    props.getFairs()
    props.getStages()
    props.getUsers()
  }, [])

  useEffect(() => {
    let temp = _.cloneDeep(props.searchParams)
    temp[0]['options'] = props.fairs
    temp[3]['options'] = props.stages

    props.onChangeProgrammeHOC('searchParams', temp)
  }, [props.fairs, props.stages])

  useEffect(() => {
    if (!props.showEditModal) {
      props.onChangeProgrammeHOC('selectedProgramme', {})
    }
  }, [props.showEditModal])

  const permissionHandle = (context) => {
    let tmp = _.find(props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if (tmp) {
      tmpModules = _.find(tmp.modules, { name: 'Fair' })
      return props.subscribedPackage && tmpModules[context]
    }
  }

  const renderCreateProgrammeForm = () => (
    <Modal isOpen={props.showCreateProgramme} size='xl' >
      <ProgrammeForm
        clientID={props.data.selectCenterReducer.selectedCenter.center.client_id}
        data={props.data}
        fairs={props.fairs}
        users={props.users}
        stages={props.stages}
        mode={'create'}
        onSubmit={props.createProgramme}
        pages={props.pages}
        anchorLinks={props.anchorLinks}
        toggleMediaDatabase={props.toggleMediaDatabase}
        onClose={() => props.onChangeProgrammeHOC('showCreateProgramme', false)}
      />
      {props.onLoadProgrammeHOC && <LoadingOverlay />}
    </Modal>
  )

  const renderUpdateProgrammeForm = () => (
    <Modal isOpen={props.showEditModal} size='xl' >
      <ProgrammeForm
        clientID={props.data.selectCenterReducer.selectedCenter.center.client_id}
        mode={'edit'}
        fairs={props.fairs}
        users={props.users}
        stages={props.stages}
        selectedProgramme={props.selectedProgramme}
        anchorLinks={props.anchorLinks}
        pages={props.pages}
        toggleMediaDatabase={props.toggleMediaDatabase}
        data={props.data}
        onSubmit={props.updateProgramme}
        onClose={() => props.onChangeProgrammeHOC('showEditModal', false)}
      />
      {props.onLoadProgrammeHOC && <LoadingOverlay />}
    </Modal>
  )

  return (
    <>
      <PageTitle
        heading={Lang['PROGRAMME'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-box2 icon-gradient bg-happy-itmeo"
        buttons={[
          {
            buttonText: Lang['CREATE_PROGRAMME'][props.data.languageReducer.userSettings.admin_panel_language],
            onClick: () => props.onChangeProgrammeHOC('showCreateProgramme', true),
            display: permissionHandle('is_create')
          }
        ]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          <Row>
            <Col md={12}>
              <SearchForm
                searchParams={props.searchParams}
                onChangeHOCState={props.onChangeProgrammeHOC}
                defaultQuery={props.defaultQuery}
                getListAPI={val => props.getProgramme({
                  ...val,
                  filter: {
                    ...val.filter,
                    "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id
                  }
                })}
              />
            </Col>
            <Col md={12}>
              <Card className='main-card mb-3 p-4' >
                <ReactTable
                  defaultPageSize={10}
                  showPagination={false}
                  NoDataComponent={() => <span></span>}
                  data={props.programmes}
                  columns={[
                    {
                      Header: Lang['DATE'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'start_date_time',
                      Cell: row => row.original.start_date_time
                        ? Moment(row.original.start_date_time).format('YYYY-MM-DD')
                        : '-'
                    },
                    {
                      Header: Lang['TITLE'][props.data.languageReducer.userSettings.admin_panel_language],
                      Cell: row => typeof row.original.short_description === 'object'
                        ? row.original.short_description[props.data.languageReducer.userSettings.admin_panel_language]
                        : row.original.short_description
                    },
                    {
                      Header: `${Lang['USERS'][props.data.languageReducer.userSettings.admin_panel_language]}, ${Lang['COMPANY'][props.data.languageReducer.userSettings.admin_panel_language]}`,
                      Cell: row => `${row.original.first_name} ${row.original.last_name}, ${row.original.company_name}`
                    },
                    {
                      Header: Lang['STAGES'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'stage_id',
                      Cell: row => row.original.stage_title[props.data.languageReducer.userSettings.admin_panel_language]
                    },
                    {
                      Header: Lang['TIME'][props.data.languageReducer.userSettings.admin_panel_language],
                      Cell: row => (
                        (row.original.start_date_time && row.original.end_date_time)
                          ? `${Moment(row.original.start_date_time).format('HH:mm')} -
                          ${Moment(row.original.end_date_time).format('HH:mm')}`
                          : '-'
                      )
                    },

                    {
                      Header: Lang['ACTIONS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'id',
                      style: {
                        "justify-content": "center"
                      },
                      Cell: row => (
                        <>
                          {
                            permissionHandle('is_update') && (
                              <>
                                <Button
                                  className="mb-2 mr-2 mt-2 btn-icon btn-icon-only"
                                  color='primary'
                                  id={`portal-user-${row.original.id}-edit-btn`}
                                  onClick={() => {
                                    props.onChangeProgrammeHOC('selectedProgramme', row.original)
                                    props.onChangeProgrammeHOC('showEditModal', true)
                                  }} >
                                  <i className="pe-7s-pen btn-icon-wrapper" />
                                </Button>
                                <UncontrolledTooltip
                                  target={`portal-user-${row.original.id}-edit-btn`}
                                  placement="top">
                                  {Lang['EDIT'][props.data.languageReducer.userSettings.admin_panel_language]}
                                </UncontrolledTooltip>
                                <Button
                                  className="mb-2 mt-2 mr-2 btn-icon btn-icon-only"
                                  color={'danger'}
                                  id={`portal-user-${row.original.id}-bin-btn`}
                                  onClick={() => {
                                    props.onChangeProgrammeHOC('selectedProgramme', row.original)
                                    props.onChangeProgrammeHOC('showDeleteConfirmation', true)
                                  }}>
                                  <i className="pe-7s-trash btn-icon-wrapper" />
                                </Button>
                                <UncontrolledTooltip
                                  target={`portal-user-${row.original.id}-bin-btn`}
                                  placement="top">
                                  {Lang['DELETE'][props.data.languageReducer.userSettings.admin_panel_language]}
                                </UncontrolledTooltip>

                                <UncontrolledTooltip
                                  target={`portal-user-${row.original.id}-edit-btn`}
                                  placement="top">
                                  {Lang['EDIT'][props.data.languageReducer.userSettings.admin_panel_language]}
                                </UncontrolledTooltip>
                                <Button
                                  className="mb-2 mt-2 btn-icon btn-icon-only"
                                  color={'danger'}
                                  id={`portal-user-${row.original.id}-cancel-btn`}
                                  onClick={() => {
                                    props.onChangeProgrammeHOC('selectedProgramme', row.original)
                                    props.onChangeProgrammeHOC('showCancelConfirmation', true)
                                  }}>
                                  <i className="pe-7s-close-circle btn-icon-wrapper" />
                                </Button>
                                <UncontrolledTooltip
                                  target={`portal-user-${row.original.id}-cancel-btn`}
                                  placement="top">
                                  {Lang['UNASSIGN'][props.data.languageReducer.userSettings.admin_panel_language]}
                                </UncontrolledTooltip>
                              </>
                            )
                          }
                        </>
                      )
                    }
                  ]}
                />
                <CustomPagination
                  meta={props.programmesMeta}
                  onChangePage={val => props.getProgramme({
                    ...props.query,
                    page: val
                  })}
                />
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactCSSTransitionGroup>
      {renderCreateProgrammeForm()}
      {renderUpdateProgrammeForm()}
      {
        props.showDeleteConfirmation && (
          <DeleteConfirmationModal
            handleModalClose={() => props.onChangeProgrammeHOC('showDeleteConfirmation', false)}
            deleteOpen={props.showDeleteConfirmation}
            confirmAction={() => {
              props.deleteProgramme(props.selectedProgramme.id)
            }}
            content={Lang['PROGRAMME_DELETE_CONFIRMATION'][props.data.languageReducer.userSettings.admin_panel_language]}
            lang={props.data.languageReducer.userSettings.admin_panel_language}
          />
        )
      }
      {
        props.showCancelConfirmation && (
          <DeleteConfirmationModal
            handleModalClose={() => props.onChangeProgrammeHOC('showCancelConfirmation', false)}
            deleteOpen={props.showCancelConfirmation}
            confirmAction={() => {
              props.updateProgramme({
                ...props.selectedProgramme,
                start_date_time: null,
                end_date_time: null,
                stage_id: null,
                fair_id: null
              })
            }}
            content={Lang['PROGRAMME_CANCEL_CONFIRMATION'][props.data.languageReducer.userSettings.admin_panel_language]}
            lang={props.data.languageReducer.userSettings.admin_panel_language}
          />
        )
      }

      {props.onLoadProgrammeHOC && <LoadingOverlay />}
    </>
  )
}

export default ProgrammeHOC(Programme)
